"use client";

import Link from "next/link";
import { trackCTA } from "@/lib/analytics";

export function Hero() {
  return (
    <section className="w-full px-6 py-16 md:py-24 lg:py-32 flex flex-col items-center text-center max-w-7xl mx-auto">
      <div className="inline-flex items-center gap-2 rounded-full border-2 border-border-thick bg-white px-4 py-1.5 shadow-brutal-sm mb-8">
        <span className="flex h-2 w-2 rounded-full bg-success" />
        <span className="text-sm font-bold font-display">AI-powered study — built for cramming week.</span>
      </div>
      <h1 className="text-4xl sm:text-5xl md:text-7xl font-black tracking-tight leading-tight mb-6 max-w-4xl font-display">
        Turn any source into{" "}
        <span className="bg-primary text-white px-2 rotate-1 inline-block border-2 border-border-thick shadow-brutal-sm">
          study cards
        </span>{" "}
        — and actually learn them.
      </h1>
      <p className="text-xl font-medium text-border-thick/60 max-w-2xl mb-12">
        Drop in a PDF, lecture video, or link. SnapCards generates flashcards with AI and drills them into your memory with spaced repetition and quiz mode. Study unlimited, every day.
      </p>

      <div className="relative w-full max-w-xl mx-auto group cursor-pointer mb-12">
        <div className="absolute -top-3 -left-3 w-full h-full border-2 border-border-thick bg-retro-gray rounded-xl" />
        <div className="relative bg-retro-gray/80 border-2 border-border-thick rounded-xl p-8 flex flex-col items-center justify-center shadow-brutal transition-transform hover:-translate-y-1 active:translate-y-1 active:shadow-none">
          <div className="w-48 h-48 bg-white border-2 border-border-thick rounded-lg relative mb-6 flex flex-col items-center p-2 shadow-brutal-sm">
            <div className="w-full h-24 bg-primary border-2 border-border-thick rounded-t-md relative overflow-hidden">
              <div className="absolute top-0 right-4 w-6 h-12 bg-white border-x-2 border-b-2 border-border-thick" />
            </div>
            <div className="mt-4 w-3/4 h-12 border-2 border-border-thick bg-retro-gray/40 flex items-center justify-center">
              <span className="text-xs font-mono font-bold">LECTURE_NOTES.PDF</span>
            </div>
          </div>
          <div className="w-full max-w-xs bg-border-thick border-4 border-border-thick rounded-md h-12 mb-4 relative shadow-[inset_0px_4px_8px_rgba(0,0,0,0.3)]">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-4/5 h-3 bg-border-thick/80 rounded" />
          </div>
          <h3 className="text-xl font-bold font-display mb-2">Upload &rarr; Study &rarr; Remember</h3>
          <p className="text-border-thick/50 font-medium mb-6">It really is that simple.</p>
          <Link
            href="/login"
            onClick={() => trackCTA("hero")}
            className="flex items-center gap-2 bg-border-thick text-white px-6 py-3 rounded-lg font-bold font-display border-2 border-transparent hover:bg-border-thick/80 transition-colors"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            Start Studying — Free
          </Link>
        </div>
      </div>
    </section>
  );
}
